// NOTE: These paths are risky since they overlap with the
// schema of PROJECT_BASE_PATH. It would be nice to always
// mediate variable route components with a static path. For
// example: `/:entityName/project/:projectName` instead of
// `/:entityName/:projectName`.

import {envIsPublicCloud} from '../../config';

// Team-level registry paths
export const ENTITY_REGISTRY_ALL_TEAMS_PATHS = [
  '/teams/registry/',
  '/teams/registry/:registryName?',
];
export const ENTITY_REGISTRY_ACCESS_CONTROL_PATH =
  '/:entityName/registry/:registryName/access-control';
export const ENTITY_REGISTRY_PATHS = [
  ...ENTITY_REGISTRY_ALL_TEAMS_PATHS,
  '/:entityName/registry/',
  '/:entityName/registry/:registryName?',
  ENTITY_REGISTRY_ACCESS_CONTROL_PATH,
];

// Organization registry paths
// Deprecated registry paths that redirect to /orgs/:orgName/registry/:registryName now
export const OLD_ORG_REGISTRY_SETTINGS_PATH =
  '/registry/:registryName/settings';
export const OLD_ENTITY_REGISTRY_ALL_TEAMS_PATHS = [
  '/registry/',
  '/registry/:registryName?',
  OLD_ORG_REGISTRY_SETTINGS_PATH,
];

export const ORG_SCOPED_REGISTRY_SETTINGS_PATH = envIsPublicCloud
  ? '/orgs/:orgName/registry/:registryName/settings'
  : '/orgs/server/registry/:registryName/settings';

export const ORG_SCOPED_REGISTRY_PATHS = envIsPublicCloud
  ? ['/orgs/:orgName/registry/', '/orgs/:orgName/registry/:registryName?']
  : ['/orgs/server/registry/', '/orgs/server/registry/:registryName?'];

export const ORG_REGISTRY_PATHS = [
  ...OLD_ENTITY_REGISTRY_ALL_TEAMS_PATHS,
  ...ORG_SCOPED_REGISTRY_PATHS,
  ORG_SCOPED_REGISTRY_SETTINGS_PATH,
];

export const REGISTRY_PATHS = [...ENTITY_REGISTRY_PATHS, ...ORG_REGISTRY_PATHS];
